import { FunctionComponent } from "react";


interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  message?: string;
  testId?: string;
}


const LoadingSpinner: FunctionComponent<LoadingSpinnerProps> = ({ 
  size = 'medium', 
  message = 'Loading...', 
  testId = 'loading-spinner' 
}) => (
  <div className="flex flex-col justify-center items-center h-64" data-testid={testId}>
    <SpinnerIcon size={size} />
    <LoadingMessage message={message} />
  </div>
);


const SpinnerIcon: FunctionComponent<{ size: string }> = ({ size }) => {
  const sizeClasses = {
    small: 'w-6 h-6',
    medium: 'w-12 h-12', 
    large: 'w-16 h-16'
  };


  return (
    <div className={`animate-spin rounded-full border-t-2 border-b-2 border-primary ${sizeClasses[size as keyof typeof sizeClasses]}`} />
  );
};


const LoadingMessage: FunctionComponent<{ message: string }> = ({ message }) => (
  <span className="sr-only">{message}</span>
);


export default LoadingSpinner;


